// @mui
import { Box } from '@mui/material';
//
import { STAGE, TYPE } from '../../theme/stage';
import { WORDMARK } from './copy';
import BisqueRing from './primitives/BisqueRing';

// ----------------------------------------------------------------------

export default function Wordmark() {
  return (
    <Box
      component="span"
      aria-hidden
      translate="no"
      sx={{ ...TYPE.navWordmark, color: STAGE.ink, whiteSpace: 'nowrap' }}
    >
      {WORDMARK.left}
      <BisqueRing size="menu" />
      {WORDMARK.right}
    </Box>
  );
}
